import { Box, styled } from '@mui/material';
import { LwButton } from 'redesign';

export const WorkflowSidebarFooter = ({
  onClose,
  submit,
}: {
  onClose: () => void;
  submit: () => void;
}) => {
  return (
    <ActionFooter>
      <LwButton iconColorMode="fill" onClick={onClose}>
        Cancel
      </LwButton>
      <LwButton iconColorMode="stroke" onClick={submit}>
        Save
      </LwButton>
    </ActionFooter>
  );
};

const ActionFooter = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2),
  boxShadow: `1px 0px 20px 0px ${theme.palette.lwBlack[10]}`,
  backgroundColor: 'white',
  zIndex: 1,
}));
